(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brands-page"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-brands-catalogue]').forEach(root=>{
  const brandButtons=[...root.querySelectorAll('[data-brand]')];
  const panels=[...root.querySelectorAll('[data-brand-panel]')];
  const heading=root.querySelector('[data-model-heading]');
  const note=root.querySelector('[data-model-note]');

  const selectBrand=button=>{
    const handle=button.dataset.brand;
    brandButtons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    panels.forEach(panel=>{
      panel.hidden=panel.dataset.brandPanel!==handle;
    });
    const activePanel=panels.find(panel=>panel.dataset.brandPanel===handle);
    if(heading){
      heading.textContent=activePanel?.dataset.heading||button.dataset.brandName;
    }
    if(note && activePanel?.dataset.note){
      note.textContent=activePanel.dataset.note;
    }
  };

  brandButtons.forEach(button=>button.addEventListener('click',()=>selectBrand(button)));
});
  } catch(e) { console.error(e); }
})();

})();
